import Product from '@common/models/Product';
import { fetchProductDetailsRequest, fetchProductReviewsRequest } from '@common/store/productDetails/slice';
import { removeToast, ToastWithKeyType } from '@common/store/toasts/slice';
import history from '@common/utils/history';
import Details from '@images/Zoom.svg';
import Image from '@lib/Image';
import React from 'react';

export interface ProductCardOverlayProps {
  product: Product;
  fetchProductDetailsRequest: typeof fetchProductDetailsRequest;
  fetchProductReviewsRequest: typeof fetchProductReviewsRequest;
  removeToast: typeof removeToast;
  toasts: ToastWithKeyType;
  CloseDetails: boolean;
  SetCloseDetails: (close: boolean) => void;
  computedProductLink: string;
}

const ProductCardOverlay: React.FC<ProductCardOverlayProps> = ({
  product,
  toasts,
  fetchProductDetailsRequest,
  fetchProductReviewsRequest,
  computedProductLink,
  CloseDetails,
  SetCloseDetails,
}) => {
  return (
    <>
      <div
        style={{ backgroundColor: 'rgba(51, 51, 51, 0.7)', transition: '0.6s' }}
        className="hidden md:block rounded-3xl absolute inset-0 opacity-0 hover:opacity-100"
      >
        <div
          className="w-full h-full flex justify-center cursor-pointer"
          onClick={() => {
            history.push(computedProductLink);
          }}
        >
          <button
            style={{ top: '45%' }}
            className="rounded-full bg-white h-40 px-20 w-143 text-center absolute text-14 
              tracking-196 font-bold pointer-events-auto"
            onClick={(e) => {
              e.stopPropagation();
              fetchProductDetailsRequest(product.slug);
              fetchProductReviewsRequest(product.slug);
              SetCloseDetails(!CloseDetails);
              toasts.length ? toasts.map((t) => removeToast(t.key)) : null;
            }}
            font-customisation="para-text"
            button-customisation="page-button"
          >
            QUICK VIEW
          </button>
        </div>
      </div>
      <button
        className="bg-subtheme block w-36 h-36 md:hidden absolute bottom-0 p-12 right-0 rounded bg-productHover opacity-90"
        onClick={() => {
          fetchProductDetailsRequest(product.slug);
          fetchProductReviewsRequest(product.slug);
          SetCloseDetails(!CloseDetails);
          toasts.length ? toasts.map((t) => removeToast(t.key)) : null;
        }}
      >
        <Image src={Details} alt="details" noDefaultDimensions noDefaultFit />
      </button>
    </>
  );
};

export default ProductCardOverlay;
